import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet';
import SocialMediaLinks from '../socialMediaLinks'
import DoneByHumans from '../../pics/DoneByHumans.png'


import './footer.css'

class Footer extends React.Component {

	componentDidMount() {
		if (typeof window === 'undefined') return;

		const existingStyle = document.querySelector(
			'link[href="https://dashboard.lechat.app/assets/widget/styles.css"]'
		);

		if (!existingStyle) {
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = 'https://dashboard.lechat.app/assets/widget/styles.css';
			document.head.appendChild(link);
		}

		const existingScript = document.querySelector(
			'script[src="https://dashboard.lechat.app/assets/widget/lechat.js"]'
		);

		const initWidget = () => {
			if (window.LeChatWidget && !window.__lechatInitialized) {
				window.__lechatInitialized = true;
				new window.LeChatWidget({
					companyName: "1714833061133f4743eb3-04ce-497d-ac7d-a97025d6e17eu"
				});
			}
		};

		if (existingScript) {
			if (window.LeChatWidget) {
				initWidget();
			} else {
				existingScript.addEventListener('load', initWidget, { once: true });
			}
			return;
		}

		const script = document.createElement('script');
		script.src = 'https://dashboard.lechat.app/assets/widget/lechat.js';
		script.async = true;
		script.onload = initWidget;
		document.body.appendChild(script);
	}

	render() {

		return (

			<footer className="black">


				<div className="grid-1-1-1-1 footerNav">
					<div>
						<h2>AI courses</h2>

						<Link
							to="/vibe-coding-bootcamp-with-claude/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Vibe Coding Bootcamp
						</Link>

						<Link
							to="/ai-business-automation-architect/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ AI Agent & Automation Bootcamp
						</Link>

						<Link
							to="/n8n-course/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ n8n Course
						</Link>

						<Link
							to="/ai-agents-builder-course/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ AI Agents Builder
						</Link>

						<Link
							to="/work-automation-with-ai-agents/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Work automation with AI agents
						</Link>

						<Link
							to="/ai-compliance-training/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ AI Act Compliance Training
						</Link>

						{/* <Link
							to="/ai-agent-engineer-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ AI Agent & Automation Bootcamp
						</Link> */}


						<Link
							to="/machine-learning-and-ai-engineering-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Deep Learning and AI Engineering Bootcamp
						</Link>








						<h2 style={{
							marginTop: '1em',
						}}>Design courses</h2>

						<Link
							to="/ux-design-bootcamp-in-barcelona-code-school/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ UX/UI Design with AI full-time Bootcamp
						</Link>





						<Link
							to="/ux-design-online-mentored-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ UX/UI Design with AI part-time Bootcamp
						</Link>

						<Link
							to="/design-and-prototype-in-figma/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Figma Crash Course
						</Link>


						<h2 style={{
							marginTop: '1em',
						}}>GameDev courses</h2>



						<Link
							to="/game-development-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Game Development Bootcamp
						</Link>

						<Link
							to="/game-development-online-bootcamp"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Game Development part-time Bootcamp
						</Link>



					</div>






					<div>


						<h2>
							Coding courses
						</h2>

						<Link
							to="/barcelona-code-school/javascript-full-stack-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Web / Mobile Development with AI full-time Bootcamp
						</Link>

						<Link
							to="/barcelona-code-school/javascript-full-stack-online-bootcamp/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Web / Mobile Development with AI part-time Bootcamp
						</Link>

						<Link
							to="/programming-with-javascript/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Programming with JavaScript
						</Link>


						<Link
							to="/responsive-web-design-with-css3/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Responsive web design / CSS3
						</Link>

						<Link
							to="/reactjs-crash-course/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',

							}}
						>
							→ React.js Crash Course
						</Link>

						<Link
							to="/backend-development-with-node-express-mongodb/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',

							}}
						>
							→ Back-end development with Express
						</Link>


						{/* <Link
							to="/bcs-young-coders-summer-camp-2026"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Young Coders Summer Camp 2026
						</Link> */}

						<a
							href="https://www.udemy.com/course/html-and-css-for-the-total-newbies/?referralCode=3463E1667BB1FD9D016C"
							target='_blank'
							rel='noreferrer noopeners'
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ HTML & CSS for the total newbies
						</a>

						<a
							href="https://www.udemy.com/course/programming-with-python-bcs/?referralCode=9B251D06407ACC8D5DBC"
							target='_blank'
							rel='noreferrer noopeners'
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Programming with Python
						</a>
						{/* <a
							href="https://www.udemy.com/course/real-time-apps-with-socket-io-react-and-express/?referralCode=08B75162BEC2699422FF"
							target='_blank'
							rel='noreferrer noopeners'
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Real-time apps with Socket.IO
						</a> */}
						<a
							href="https://www.udemy.com/course/sending-emails-with-nodemailer-gmail-and-oauth2/?referralCode=53A07520999CD0870D6B"
							target='_blank'
							rel='noreferrer noopeners'
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→  Sending emails with ExpressJS, Nodemailer, Gmail and OAuth2
						</a>
						<a
							href="https://www.udemy.com/course/backend-development-with-nodejs-expressjs-mongodb/?referralCode=53A07520999CD0870D6B"
							target='_blank'
							rel='noreferrer noopeners'
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→  Backend development with NodeJS, ExpressJS, mongoDB
						</a>



						{/* <Link
							to="/online-short-courses/programming-with-javascript-online-course/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Programming with JavaScript Online Course
						</Link>

						<Link
							to="/online-short-courses/react-crash-course-online/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ React.js Online Crash Course
						</Link>

						<Link
							to="/online-short-courses/backend-development-with-node-express-mongodb-online/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Back-end development with Express Online course
						</Link>

						<Link
							to="/online-short-courses/responsive-web-design-with-css3-online/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Responsive web design with HTML5/CSS3
						</Link> */}


					</div>

					<div>
						<h2>School</h2>
						{/*<Link 
				to="/calendar/"
				style={{
					textDecoration: 'none',
					marginRight: '1em',
				}}
				>
				→ Calendar
			</Link>*/}

						<Link
							to="/contacts/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Contacts
						</Link>

						<Link
							to="/about-us/school/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ About us
						</Link>

						<Link
							to="/events/ai-agent-workshop-barcelona/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Events
						</Link>

						<Link
							to="/about-us/testimonials/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Testimonials
						</Link>


						<Link
							to="/about-us/instructors/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Instructors
						</Link>

						<Link
							to="/about-us/career-services/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Career Services
						</Link>


						<Link
							to="/corporate-training/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Private training
						</Link>

							<Link
								to="/job-offer/"
								style={{
									textDecoration: 'none',
									marginRight: '1em',
								}}
							>
								→ Hire developers
							</Link>

							<Link
								to="/corporate-training/"
								style={{
									textDecoration: 'none',
									marginRight: '1em',
								}}
							>
								→ Corporate training
							</Link>

							<Link
								to="/ai-implementation-in-barcelona-code-school/"
								style={{
									textDecoration: 'none',
									marginRight: '1em',
								}}
							>
								→ AI implementation
							</Link>

						<Link
							to="/blog/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Blog
						</Link>
						<Link
							to="/ai-talks/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ AI Talks
						</Link>
						<Link to="/lab/" style={{ textDecoration: 'none', marginRight: '1em' }}>
							→ BCS Lab
						</Link>
						<Link
							to="/about-us/terms-and-conditions/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Terms and Conditions
						</Link>
						<Link
							to="/about-us/privacy-policy/"
							style={{
								textDecoration: 'none',
								marginRight: '1em',
							}}
						>
							→ Privacy Policy
						</Link>
					</div>

					<div>
						<h2>Get in touch</h2>
						<SocialMediaLinks color={'white'} />
						<a href='https://zcal.co/i/c9mEbhSA' target='_blank' style={{ marginBottom: '1em' }}>→ Book a meeting/call with us</a>
						<a href='mailto:office@barcelonacodeschool.com' style={{ marginBottom: '1em' }}>→ office@barcelonacodeschool.com</a>
						<p>→Our campus:</p>
						<p>Carrer de Paris 157, 08036, Barcelona, Spain</p>
						<p></p>
						<p>→ Give us a call:</p>
						<a href="tel:+34936639807" style={{ marginBottom: '1em' }}>+34 936 639 807</a>
						<p>Mon-Fri, 9:00-18:00</p>
						<a href='https://zcal.co/i/3qm10eD2' target='_blank' style={{ marginBottom: '1em' }}>→ Open House every Thursday, RSVP here</a>
					</div>

				</div>

				<p className="copyrights">Copyright © 2015-{(new Date).getFullYear()} — Barcelona Code School | Upgrade Yourself!</p>
				<p className="legalname">Arms and Legs FOM SL | B66750365</p>
				<a href='https://www.thisisdonebyhumans.org/badges/barcelonacodeschool.com' target='_blank' rel='noopener noreferrer' id='doneByHumansLink'>
					<img id='doneByHumans' src={DoneByHumans} alt='This Is Done By Humans' />
				</a>
			</footer>
		)
	}
}

export default Footer
